import {AfterViewInit, Component, Inject, QueryList, ViewChild} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InteractPoDPage} from '../../api/models/interact-po-dpage';
import {Observable} from 'rxjs/internal/Observable';
import {MatList, MatListOption, MatSelectionList, MatSelectionListChange} from '@angular/material/list';

export enum PrintOnDemandFileType {
  PDF = 0,
  PPTX = 1,
  PNG = 2,
  XLSX = 3,
  DOCX = 4,
  CSV = 5,
  XML = 6,
  MHTML = 7
}

export class PrintOnDemandDialogData {
  fileType: PrintOnDemandFileType;
  pages: InteractPoDPage[];
  selectedPages: InteractPoDPage[];
}

export class PrintOnDemandDialogResult {
  fileType: PrintOnDemandFileType;
  selectedPages: InteractPoDPage[];
}

@Component({
  selector: 'print-on-demand-dialog',
  templateUrl: './print-on-demand-dialog.component.html',
})
export class PrintOnDemandDialogComponent {

  results: PrintOnDemandDialogResult = {
    fileType: PrintOnDemandFileType.PDF,
    selectedPages: []
  };

  constructor(
    public dialogRef: MatDialogRef<PrintOnDemandDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrintOnDemandDialogData
  ) {

    if (data.selectedPages && data.selectedPages.length > 0) {
      this.results.selectedPages = JSON.parse(JSON.stringify(data.selectedPages));
    } else {
      this.results.selectedPages = JSON.parse(JSON.stringify(data.pages));
    }

    this.results.fileType = data.fileType;

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  isOptionSelected(page: InteractPoDPage) {
    return this.results.selectedPages.findIndex(x => x.page === page.page) >= 0
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    fileType: PrintOnDemandFileType,
    pages: InteractPoDPage[],
    selectedPages: InteractPoDPage[]
  ): Observable<any> {
    const params: PrintOnDemandDialogData = {
      fileType,
      pages,
      selectedPages
    };

    const dialogRef = dialog.open(PrintOnDemandDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.finishDialog();
  }

  onPrintPreview(): void {
    this.finishDialog();
  }

  private finishDialog(): void {
    this.results.selectedPages.sort((a, b) => a.order -b.order);
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.results;
    this.dialogRef.close(this.Result);
  }

  onSelectionChange(event: MatSelectionListChange) {
    this.results.selectedPages = event.source.selectedOptions.selected.map(item => JSON.parse(JSON.stringify(item.value)));
  }
}
